import { render, staticRenderFns } from "./remove-reminder-summary.vue?vue&type=template&id=1a017ab8&"
import script from "./remove-reminder-summary.vue?vue&type=script&lang=js&"
export * from "./remove-reminder-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports